import { render, staticRenderFns } from "./reportStoragePath.vue?vue&type=template&id=12274df1&scoped=true"
import script from "./reportStoragePath.vue?vue&type=script&lang=js"
export * from "./reportStoragePath.vue?vue&type=script&lang=js"
import style0 from "./reportStoragePath.vue?vue&type=style&index=0&id=12274df1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12274df1",
  null
  
)

export default component.exports